import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ReactComponent as ContentDrop } from '../assets/svg/contentDrop.svg'

const SidebarItem = ({ item, homeStatus, renderIcon, collapsed, setHomeStatus, isOpen, onToggle }) => {
    const { t } = useTranslation()
    const selected = item.path?.some((p) => p.startsWith(homeStatus))
    // The visible <span> is unmounted while the rail is collapsed, so the label has to
    // live on the focusable element itself to keep an accessible name in both states.
    const label = t(item.title)

    if (item?.options && item?.options?.length > 0) {
        return (
            <div id={`sidebar-navigation-button-${item.name}`} data-title={label} className={`my-0 xl3:my-3 ${item.className}`}>
                <button type="button" onClick={() => onToggle(item)} aria-label={label} title={label} aria-expanded={isOpen} className="pointer cursor-pointer w-full text-left">
                    <div className={`h-[45px] 2xl:h-[52px] flex flex-row items-center relative transition-[height]`}>
                        <div className="items-center">{renderIcon(item?.name, selected ? '#FDDF6D' : '#F8F8FB')}</div>
                        {item?.icon}
                        {!collapsed && (
                            <span className={`px-3 flex justify-between items-center w-full ellipsis ${selected ? ' text-highlightColor' : ''}`}>
                                {label} <ContentDrop aria-hidden="true" focusable="false" />
                            </span>
                        )}
                    </div>
                </button>
                <div className={`items-start pl-10 ${isOpen ? 'flex flex-col' : 'hidden'}`}>
                    {item?.options?.map((option, index) => (
                        <Link to={option.path} className="my-2" onClick={() => setHomeStatus(option.path)} key={index} aria-label={t(option?.title)} title={t(option?.title)}>
                            <div id={`sidebar-navigation-nested-button-${option.title}`} className={`leading-[25px] ${option?.path === homeStatus ? 'text-highlightColor' : ''}`}>
                                {t(option?.title)}
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        )
    }

    return (
        <div id={`sidebar-navigation-button-${item.name}`} data-title={label} className={`my-0 xl3:my-3 ${item.className}`}>
            <Link to={item?.path[0]} aria-label={label} title={label}>
                <div className={`h-[45px] 2xl:h-[52px] flex flex-row items-center relative w-full cursor-pointer transition-[height]`}>
                    <div className="items-center">{renderIcon(item?.name, selected ? '#FDDF6D' : '#F8F8FB')}</div>
                    {!!item?.icon && <div className="chat-badge-wrapper">{item?.icon}</div>}
                    {!collapsed && <span className={`px-3 w-full ellipsis text-ellipsis ${selected ? ' text-highlightColor' : ''}`}>{label}</span>}
                </div>
            </Link>
        </div>
    )
}

export default SidebarItem
